import instance from '../../config/axiosConfig';
export const UPDATE_REVERSAL_COUNT = 'UPDATE_REVERSAL_COUNT';

export const updateReversalCount = (count) => ({
  type: UPDATE_REVERSAL_COUNT,
  payload: count
});

export const fetchReversalCount = () => {
  return async (dispatch) => {
    try {
      const { data } = await instance.get(
        `acppayvous/pending/reversal?companyId=${localStorage.getItem('CompaneyId')}`
      );
      if (data && data.length > 0) {
        dispatch(updateReversalCount(data.length));
      } else {
        dispatch(updateReversalCount(0));
      }
    } catch (error) {
      console.log(error);
      dispatch(updateReversalCount(0));
    }
  };
};
